import React, { Fragment } from "react";
import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Appfooter from "../components/Appfooter";
import AccountSettings from "../components/AccountSettings"; // ← 新コンポーネント

const Account = () => {
  return (
    <Fragment>
      <Header />
      <Leftnav />
      <AccountSettings />
      <Appfooter />
    </Fragment>
  );
};

export default Account;
